import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationFamilyCmConstants {
    static STEP_TITLE = "Family";
    static FAMILY_FORM_CONTROL_NAME = "family";
    static FAMILY_LABEL = "Family";
    static COPY_APPLICANT_TO_FAMILY_LABEL = "Copy applicant to family";
    static VALIDATION_MESSAGES = {
        family: {
            required: `Family ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
